import { useEffect } from "react";
import { useRouteError } from "react-router-dom";

import { describeRouteError, logRouteError } from "./logRouteError";

/**
 * The last-ditch fallback, for when the App shell itself fails to render. There
 * is no header, sidebar or router state to rely on at that point, so this stays
 * deliberately plain: no app chrome, no navigation, just a way to start over.
 */
export function AppCrashPage() {
  const error = useRouteError();
  const { detail } = describeRouteError(error);

  useEffect(() => {
    logRouteError(error, "AppCrashPage");
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <h1 className="poppins text-xl font-bold tracking-tight text-text-primary">
        Clubhouse couldn&apos;t start.
      </h1>
      <p className="max-w-md text-sm text-text-muted">
        Reloading usually clears this. If it doesn&apos;t, let support know what
        you were doing.
      </p>
      {detail && (
        <pre className="max-w-xl overflow-x-auto rounded-lg bg-muted px-4 py-3 text-left text-xs text-text-muted">
          {detail}
        </pre>
      )}
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-xl bg-primary px-4 py-2 text-sm font-bold text-primary-foreground"
      >
        Reload
      </button>
    </div>
  );
}
